module.exports = __webpack_public_path__ + "9e532933223e8a595d2b1d726e5ed042.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/el pibe.png
// module id = 597
// module chunks = 0